import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useSkipLink } from './hooks/useSkipLink';

export const SkipLink: React.FC = () => {
	const {
		data: { skipLink, shouldRender },
		actions: { onSkipLinkClick },
	} = useSkipLink();

	if (!shouldRender) {
		return null;
	}

	return (
		<div className="my-4 text-center">
			<Button as="a" href={skipLink} variant="tertiary" onClick={onSkipLinkClick} data-qa="skip-link">
				<Translate value="corgi.petition_actions.skip" />
			</Button>
		</div>
	);
};
